import React from 'react';

const evaluateCondition = (shouldDisplay) => {
  if (
    shouldDisplay === null ||
    shouldDisplay === undefined ||
    shouldDisplay === 'Always'
  ) {
    return true;
  }
  if (shouldDisplay === 'Never') {
    return false;
  }
  // If it is none of the above, then is one where the display is dependant of a token.
  return shouldDisplay.split(' ')[1] !== '';
};

export const ConditionalDisplayComponent = (Component) => {
  return (props) => {
    const { shouldDisplay, ...otherProps } = props;
    if (!evaluateCondition(shouldDisplay)) {
      return null;
    }
    return <Component {...otherProps} />;
  };
};
